<label [class.disabled]="disabled || !available" [class.theme1]="theme==='theme1'" [class.checked]="check"
    [class.checked1]="check && theme==='theme1'">
    <input type="checkbox" [(ngModel)]="check" [disabled]="disabled" (change)="change()">
    <span class="icon">
        <i class="flaticon-exclamation" *ngIf="!available"></i>
        <svg *ngIf="available" width="12px" height="10px" viewbox="0 0 12 10">
            <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
        </svg>
    </span>
    <span class="lab">{{label}}</span>
</label>